<template>
  <div class="p-question__header">
    <div class="chapterTitle">
      <div class="chapterTitle__inner">
        <slot name="chapterTitle"></slot>
      </div>
    </div>

    <slot name="chapterPageNumber"></slot>
    <div class="correctWrong">
      <slot name="chapterCorrectWrongList"></slot>
    </div>
    <slot name="previousNextButton"></slot>
    <div class="closeBtn jsPopupButton" @click="emit('click')" :name="name">
      <div class="closeBtn__inner"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
      name?: string;
    }>(),
    {
      name: '',
    }
  );
  const emit = defineEmits<{
    (e: 'click'): void,
  }>()
</script>
